import React from "react";

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  className = "max-w-md",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 p-4 overflow-y-auto">
      <div className="flex items-center justify-center">
        <div className={`bg-white rounded-lg w-full mx-auto ${className}`}>
          {/* Header */}
          <div className="flex justify-between items-center px-4 py-2 border-b print:hidden">
            <h2 className="text-lg font-semibold">{title}</h2>
            <button
              onClick={onClose}
              className="text-2xl text-gray-500 hover:text-gray-800 focus:outline-none"
            >
              &times;
            </button>
          </div>

          {/* Content */}
          <div className="p-4 over">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
